import SignaturePad from "signature_pad";
import { SignatureFormat } from "../signature-types.js";
import { createCanvas, getCroppedCanvas, getScaledCanvas, createCanvasFromDataUrl } from "./canvas.js";
import { MAX_HEIGHT } from "./constants.js";
import { decodePoints } from "./points.js";
import { writeTextOnCanvas } from "./text.js";
const DATA_URI_REGEX = /^data:([^;,]+)(?:;([^,]+))?,(.+)$/;
function isDataUrl(dataUrl) {
  return DATA_URI_REGEX.test(dataUrl);
}
function decodeDataUrl(dataUrl) {
  if (!dataUrl) {
    return void 0;
  }
  const match = dataUrl.match(DATA_URI_REGEX);
  if (!match) {
    return void 0;
  }
  const [, mimeType, encoding, data] = match;
  return {
    data: encoding === "base64" ? atob(data) : decodeURI(data),
    mimeType,
    encoding
  };
}
function encodeDataUrl({
  data,
  mimeType,
  encoding = "text"
}) {
  const encodedData = encoding === "base64" ? btoa(data) : encodeURI(data);
  const typeAndEncoding = encoding === "base64" ? `${mimeType};base64` : mimeType;
  return `data:${typeAndEncoding},${encodedData}`;
}
function dataUrlToFile(dataUrl, filename) {
  const decoded = decodeDataUrl(dataUrl);
  if (!decoded) {
    return void 0;
  }
  let n = decoded.data.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = decoded.data.charCodeAt(n);
  }
  const extension = decoded.mimeType.split("/")[1] ?? "txt";
  return new File([u8arr], `${filename}.${extension}`, {
    type: decoded.mimeType
  });
}
function dataUrlToWixFile(url, displayName = "temp") {
  const decoded = decodeDataUrl(url);
  return {
    fileId: "temp",
    displayName,
    url,
    fileType: decoded?.mimeType ?? ""
  };
}
async function dataUrlToPngDataUrl(dataUrl, rtl) {
  const decodedDataUrl = decodeDataUrl(dataUrl);
  if (!decodedDataUrl) {
    return dataUrl;
  }
  const dataUrlType = decodedDataUrl.mimeType;
  if (dataUrlType === SignatureFormat.TEXT) {
    const canvas = createCanvas(MAX_HEIGHT * 20, MAX_HEIGHT, 1);
    writeTextOnCanvas(canvas, decodedDataUrl.data, "black", rtl, "white");
    const croppedCanvas = getCroppedCanvas(canvas, "white");
    return croppedCanvas?.toDataURL("image/jpeg", 0.7) ?? null;
  }
  if (dataUrlType === SignatureFormat.POINTS) {
    const points = decodePoints(dataUrl);
    if (!points) {
      return null;
    }
    const blackPoints = points.map((pointGroup) => ({
      ...pointGroup,
      penColor: "black"
    }));
    const canvas = createCanvas(
      MAX_HEIGHT * 20,
      MAX_HEIGHT,
      Math.max(window.devicePixelRatio || 1, 1)
    );
    const signaturePad = new SignaturePad(canvas);
    signaturePad.fromData(blackPoints);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      return null;
    }
    const scaledCanvas = getScaledCanvas(
      croppedCanvas,
      void 0,
      MAX_HEIGHT,
      "white"
    );
    return scaledCanvas.toDataURL("image/jpeg", 0.7);
  }
  if (dataUrlType?.startsWith("image/")) {
    const canvas = await createCanvasFromDataUrl(dataUrl);
    const croppedCanvas = getCroppedCanvas(canvas);
    if (!croppedCanvas) {
      return null;
    }
    const scaledCanvas = getScaledCanvas(croppedCanvas, void 0, MAX_HEIGHT);
    return scaledCanvas.toDataURL("image/jpeg", 0.7);
  }
  return dataUrl;
}
async function convertToPNGFile(dataUrl, rtl) {
  const pngDataUrl = await dataUrlToPngDataUrl(dataUrl, rtl);
  if (!pngDataUrl) {
    return void 0;
  }
  return dataUrlToFile(pngDataUrl, "signature");
}
export {
  convertToPNGFile,
  dataUrlToFile,
  dataUrlToPngDataUrl,
  dataUrlToWixFile,
  decodeDataUrl,
  encodeDataUrl,
  isDataUrl
};
//# sourceMappingURL=data-url.js.map
